import { Dialog, DialogActions, DialogContent, DialogTitle, makeStyles, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React from 'react';

const useStyles = makeStyles(theme => ({
    titleContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    title: {
        fontWeight: 600,
        size: "1.125rem",
    },
    unstyledButton: {
        backgroundColor: "transparent",
        border: 0,
        margin: 0,
        padding: 0,
        lineHeight: 0,
        cursor: "pointer",
    }
}));

const PsyDialog = ({ title, onClose, open, renderActions, children, ...props }) => {
    const styles = useStyles();

    return (
        <Dialog
            open={open}
            {...props}
        >
            <DialogTitle
                className={styles.titleContainer}
                disableTypography
            >
                <Typography classes={{
                    root: styles.title,
                }}
                    variant="h6">
                    {title}
                </Typography>
                <button onClick={onClose} className={styles.unstyledButton}>
                    <Close />
                </button>
            </DialogTitle>
            <DialogContent>
                {children}
            </DialogContent>
            {
                (typeof renderActions === "function") &&
                <DialogActions>
                    {renderActions()}
                </DialogActions>
            }
        </Dialog >
    );
};
export default PsyDialog;